
import { useEffect } from "react";

interface SEOManagerProps {
  currentView: string;
  currentQuery: string;
}

export const SEOManager = ({ currentView, currentQuery }: SEOManagerProps) => {
  const updateSEOTags = (view: string, query?: string) => {
    const head = document.head;
    
    // Remove existing dynamic meta tags
    const existingTitle = head.querySelector('title');
    const existingDescription = head.querySelector('meta[name="description"]');
    const existingKeywords = head.querySelector('meta[name="keywords"]');
    
    let title = "VakantieUitzoeken.com - Vind jouw perfecte vakantie";
    let description = "Ontdek duizenden vakanties, van budget-vriendelijke deals tot luxe reizen en avontuurlijke rondreizen.";
    let keywords = "vakantie, reizen, deals, luxe vakanties, rondreizen, goedkope vakanties";
    
    switch (view) {
      case "search":
        title = query ? `Vakantie zoeken: ${query} | VakantieUitzoeken.com` : "Zoekresultaten | VakantieUitzoeken.com";
        description = query ? `Vind de perfecte vakantie voor ${query}. Bekijk onze selectie van vakanties, deals en reizen.` : "Bekijk de zoekresultaten voor jouw perfecte vakantie.";
        keywords = `${query}, vakantie, reizen, ${keywords}`;
        break;
      case "deals":
        title = "Beste Vakantie Deals | Goedkope Vakanties | VakantieUitzoeken.com";
        description = "Ontdek de beste vakantie deals en goedkope vakanties. Bespaar geld op jouw droomvakantie met onze scherpe prijzen.";
        keywords = "vakantie deals, goedkope vakanties, reisdeals, korting vakantie, budget reizen, " + keywords;
        break;
      case "luxury":
        title = "Luxe Vakanties | Exclusieve Reizen | VakantieUitzoeken.com";
        description = "Geniet van onvergetelijke luxe vakanties en exclusieve reizen. Ontdek de mooiste bestemmingen met eersteklas service.";
        keywords = "luxe vakanties, exclusieve reizen, premium vakanties, luxe hotels, " + keywords;
        break;
      case "rondreizen":
        title = "Rondreizen | Avontuurlijke Reizen | VakantieUitzoeken.com";
        description = "Ontdek de wereld met onze avontuurlijke rondreizen. Van culturele expedities tot natuuravonturen.";
        keywords = "rondreizen, avontuurlijke reizen, groepsreizen, culturele reizen, " + keywords;
        break;
      case "all":
        title = "Alle Vakanties | Complete Vakantie Overzicht | VakantieUitzoeken.com";
        description = "Bekijk ons complete aanbod van vakanties. Van citytrips tot strandvakanties, van budget tot luxe.";
        keywords = "alle vakanties, vakantie overzicht, complete reisaanbod, " + keywords;
        break;
    }
    
    // Update title
    if (existingTitle) {
      existingTitle.textContent = title;
    }
    
    // Update description
    if (existingDescription) {
      existingDescription.setAttribute('content', description);
    }
    
    // Update keywords
    if (existingKeywords) {
      existingKeywords.setAttribute('content', keywords);
    }
  };

  useEffect(() => {
    updateSEOTags(currentView, currentQuery);
  }, [currentView, currentQuery]);

  return null; // This component only handles side effects
};
